var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.htmlTag,
    {
      ref: "button",
      tag: "component",
      class: _vm.buttonClasses,
      attrs: {
        dir: "auto",
        type: _vm.type,
        disabled: _vm.disabled,
        tabindex: "0",
      },
      on: {
        click: _vm.handleClick,
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.handlePressEnter.apply(null, arguments)
        },
        mouseenter: function ($event) {
          _vm.hovering = true
        },
        mouseleave: function ($event) {
          _vm.hovering = false
        },
      },
    },
    [
      _vm._t("icon"),
      _vm.icon
        ? _c("KIcon", {
            staticClass: "prop-icon",
            attrs: {
              icon: _vm.icon,
              color: _vm.iconColor,
              "data-test": "iconBefore",
            },
          })
        : _vm._e(),
      _vm._t("menu"),
      _vm.$slots.default ? _vm._t("default") : _vm._e(),
      [
        _c("span", { staticClass: "link-text", style: _vm.textStyle }, [
          _vm._v(_vm._s(_vm.text)),
        ]),
      ],
      _vm._t("iconAfter"),
      _vm.iconAfter
        ? _c("KIcon", {
            staticClass: "prop-icon",
            attrs: {
              icon: _vm.iconAfter,
              color: _vm.iconColor,
              "data-test": "iconAfter",
            },
          })
        : _vm._e(),
      _vm.hasDropdown
        ? _c("KIcon", {
            staticClass: "dropdown-arrow",
            staticStyle: { width: "24px", height: "24px" },
            style: _vm.arrowStyles,
            attrs: { icon: "dropdown", "data-test": "dropdownIcon" },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }